<script setup lang="ts">
import { useModel } from './../model/model.ts'
import './assets/style.scss'
import { useRoute } from 'vue-router'
import { VIcons } from '@/shared/ui'
import { WGlobalSearchButton } from '@/widgets/GlobalSearch'
import type { InventTab } from '@/entities/Manuals/Tabs'

const { menu, loadData } = useModel()
const route = useRoute()

const { isFetching } = loadData()

/**
 * Функция получения ссылки на вкладку
 * @param item
 */
const createLink = (item: InventTab) => {
  const type = route.params.type as String
  const object_id = route.params.object_id as string

  return `/objects/${type}/${object_id}/${item.alias}${item.params.path || ''}`
}
</script>

<template>
  <div class="w-object-menu" v-if="menu">
    <template v-for="item in menu">
      <router-link
        class="w-object-menu__link"
        :class="{ 'router-link-active': route.params.tab == item.alias }"
        :to="createLink(item)"
      >
        <VIcons :type="item.icon" />
        <p>{{ item.name }}</p>
      </router-link>
    </template>
  </div>

  <WGlobalSearchButton />
</template>
